import Fetch from "@/utils/Fetch"
import filtersToSearchParams from "@/utils/filtersToSearchParams";

export default {
	namespaced: true,
	state() {
		return {
			schedulesList: [],
            filter: {
                order: null,
                dateFrom: null,
                dateTo: null
            },
            pagination: {
                total: 0,
                offset: 0,
                limit: 10,
            },
            schedulesFilters: null,
		}
	},
	mutations: {
        setSchedulesList(state, value) {
            state.schedulesList = value
        },
        setPagination(state, paginationData) {
            if (!paginationData) return;
            Object.assign(state.pagination, {...paginationData})
        },        
        setFilter(state, filterData) {
            if (!filterData) return;
            state.filter = {...filterData};
        },
        setSchedulesFilters(state, value) {
            state.schedulesFilters = value
        },
	},
	actions: {  
        async requestSchedules({commit, dispatch, state}) {
            commit('startLoading', 'requestSchedules', {root: true})

            const {offset, limit} = state.pagination;
            const search = filtersToSearchParams(state.filter, offset, limit);

            const response = await Fetch(`tenders/schedules/${search}`, {})
            if (response.success) {
                commit('setSchedulesList', response.data?.items)
                commit('setPagination', {total: Number(response.data?.countTotal)})
            } else {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestSchedules', {root: true})

            return {
                ...response.data
            }
        },
        async requestSchedulesItem({commit, dispatch}, id) {
            commit('startLoading', 'requestSchedulesItem', {root: true})

            const response = await Fetch(`tenders/schedules/get/${id}/`)

            if (!response.success) {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestSchedulesItem', {root: true})

            return {
                ...response
            }
        },
        async requestSchedulesFilters({commit, dispatch}) {
            commit('startLoading', 'requestSchedulesFilters', {root: true})
            const response = await Fetch(`tenders/schedules/filters/`)
            if (response.success) {
                commit('setSchedulesFilters', response.data)
            } else {
                dispatch('showError', response.message, {root: true})
            }
            commit('stopLoading', 'requestSchedulesFilters', {root: true})

            return {
                ...response
            }
        },
        updatePagination({commit, dispatch}, paginationData) {
            commit('setPagination', paginationData);
            dispatch('requestSchedules', false);
        },

        updateFilter({commit, dispatch}, filterData) {
            commit('setFilter', filterData);
            commit('setPagination', {offset: 0});
            dispatch('requestSchedules', false);
        },
	},

	getters: {
        getSchedulesList: state => state.schedulesList,
        getSchedulesPagination: state => state.pagination,
        getSchedulesFilter: state => state.filter,
        getSchedulesFilters: state => state.schedulesFilters,
	}
}

